import {Layout, Anchor, Typography} from 'antd';
import React, {useState} from 'react';
import appColors from '../../style/theme';
import SafetyEthics from './SafetyEthics';
import SafetyForms from './SafetyForms';
import SafetyLab from './SafetyLab';
import SafetyProtocols from './SafetyProtocols';
import SafetyTraining from './SafetyTraining';

const {Link} = Anchor;
const {Sider, Content} = Layout;
const Text = Typography;

const handleClick = (e, link) => {
  e.preventDefault();
  console.log(link);
};
const SafetyLogic = () => {
  const [backI, setBackI] = useState('transparent');
  const [backII, setBackII] = useState('transparent');
  const [backIII, setBackIII] = useState('transparent');
  const [backIV, setBackIV] = useState('transparent');
  const [backV, setBackV] = useState('transparent');
  const ChangeAnchor = (key) => {
    console.log(key);
    if (key === '#SafetyLab') {
      setBackI(appColors['ColorA']);
      setBackII('transparent');
      setBackIII('transparent');
      setBackIV('transparent');
      setBackV('transparent');
    } else if (key === '#SafetyProto') {
      setBackI('transparent');
      setBackII(appColors['ColorA']);
      setBackIII('transparent');
      setBackIV('transparent');
      setBackV('transparent');
    } else if (key === '#Ethics') {
      setBackI('transparent');
      setBackII('transparent');
      setBackIII(appColors['ColorA']);
      setBackIV('transparent');
      setBackV('transparent');
    } else if (key === '#Training') {
      setBackI('transparent');
      setBackII('transparent');
      setBackIII('transparent');
      setBackIV(appColors['ColorA']);
      setBackV('transparent');
    } else if (key === '#SForms') {
      setBackI('transparent');
      setBackII('transparent');
      setBackIII('transparent');
      setBackIV('transparent');
      setBackV(appColors['ColorA']);
    }
  };
  return (
    <Layout style={{background: 'transparent'}}>
      <Sider style={{background: 'transparent'}}>
        <Anchor onClick={handleClick} offsetTop={75} onChange={ChangeAnchor} style={{background: 'transparent'}}>
          <Link href='#SafetyLab' title={<Content className='ContentAnchor' style={{borderColor: backI}}><Text style={{color: appColors['ColorA'], fontSize: '2.5vh'}}>Safety in the lab</Text></Content>}/>
          <Link href='#SafetyProto' title={<Content className='ContentAnchor' style={{borderColor: backII}}><Text style={{color: appColors['ColorA'], fontSize: '2.1vh'}}>Safety in protocols</Text></Content>}/>
          <Link href='#Ethics' title={<Content className='ContentAnchor' style={{borderColor: backIII}}><Text style={{color: appColors['ColorA'], fontSize: '3vh'}}>Ethics</Text></Content>}/>
          <Link href='#Training' title={<Content className='ContentAnchor' style={{borderColor: backIV}}><Text style={{color: appColors['ColorA'], fontSize: '3vh'}}>Training</Text></Content>}/>
          <Link href='#SForms' title={<Content className='ContentAnchor' style={{borderColor: backV}}><Text style={{color: appColors['ColorA'], fontSize: '3vh'}}>Safety Forms</Text></Content>}/>
        </Anchor>
        <p style={{color: appColors['ColorA'], pointerEvents: 'none', fontSize: '2vh', top: '65vh', left: '5vh', textAlign: 'center', position: 'sticky'}}> S&nbsp;<br/> A&nbsp;<br/> F&nbsp;<br/> E&nbsp;<br/> T&nbsp;<br/> Y&nbsp;</p>
      </Sider>
      <Layout style={{margin: '1% 1% 0 1%', width: 'fit-content'}}>
        <Layout style={{background: appColors['ColorX'], height: '1px'}} />
        <Layout className='PurpBack' style={{background: appColors['ColorG']}}>
          <Layout style={{margin: '0 0 0 0', background: 'transparent'}}>
            <div id='SafetyLab'>
              <SafetyLab/>
            </div>
            <div id='SafetyProto'>
              <SafetyProtocols/>
            </div>
            <div id='Ethics'>
              <SafetyEthics/>
            </div>
            <div id='Training'>
              <SafetyTraining/>
            </div>
            <div id='SForms'>
              <SafetyForms/>
            </div>
          </Layout>
        </Layout>
      </Layout>
    </Layout>
  );
};

export default SafetyLogic;
